import Vue from 'vue';
import Component from 'vue-class-component';
import {AuthorisationManager, Identity, Icon} from 'wc-lib';
import {Prop} from 'vue-property-decorator';
import {Service} from '../service';
import {MenuItem} from '../model/menu-item';

require('../../icons/forward.svg');
require('../../icons/back.svg');

@Component({
  template: require('./mobile-menu-item.html'),
  components: {
    'wc-icon': Icon
  }
})
export class MobileMenuItemComponent extends Vue {
  @Prop()
  items: MenuItem[];

  @Prop()
  level: number;

  @Prop()
  closeMenu: Function;

  @Prop()
  isParent: boolean;

  @Prop()
  toggleParentChildActive: Function;

  hasChildActive: boolean = false;

  activeItemIndex: number = -1;

  get hasActiveItem() {
    return this.activeItemIndex > -1;
  }

  subMenuItemClick(menuItemIndex: number) {
    if (menuItemIndex == this.activeItemIndex) {
      this.activeItemIndex = -1;
    } else {
      this.activeItemIndex = menuItemIndex;
    }

    if (this.toggleParentChildActive) {
      this.toggleParentChildActive();
    }
  }

  setMenuItem(item: MenuItem) {
    this.closeMenu();
    this.$store.commit('app/setCurrentMenuItem', { menuItemId: item.menuItemId, menuItemText: item.menuItemText, helpUrl: item.helpUrl });
  }

  get menuItemId() {
    return this.$store.getters['app/menuItemId'];
  }

  toggleChildElementActive() {
    this.hasChildActive = !this.hasChildActive;
  }

  href(menuItem: MenuItem) {
    if (menuItem.linkUrl.startsWith('http://') || menuItem.linkUrl.startsWith('https://')) {
      return menuItem.linkUrl;
    } else {
      return menuItem.systemId + '/' + menuItem.linkUrl;
    }
  }
}



// WEBPACK FOOTER //
// src/components/mobile-menu-item.ts